export default {"src":"/_next/static/media/snapchat.b58f1542.svg","height":243,"width":243,"blurWidth":0,"blurHeight":0};